export const teamActions = {
  GET_MEMBERS_PENDING: 'GET_MEMBERS_PENDING',
  GET_MEMBERS_SUCCESS: 'GET_MEMBERS_SUCCESS',
  GET_MEMBERS_ERROR: 'GET_MEMBERS_ERROR',
};
